import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

export const updateEmployeeProfileApi = (employeeProfile, companyIDToken) => {
  const payload = employeeProfile.filter((employee) => employee.age || employee.name);
  const url = `/small-group/select-plan/update-employee-profile?company_id_token=${companyIDToken}`;
  const request = {
    method: "POST",
    processData: false,
    body: JSON.stringify({
      employee_profile: JSON.stringify(payload),
    }),
  };
  return fetchWithCSRFToken(url, request).then((response) => response.json());
};
